import { useQuery } from "react-query";
import { Grid, Stack, Button, Card, Typography, Container, Box } from "@mui/material";
import axios from "axios";

import addCount from "Helper/addCount";

import { API_URL } from "Constants";

import DNS from "./DNS";

interface IItem {
  device: string;
  id: number;
  link: { name: string; url: string; id: number }[];
  name: string;
  picture: string;
  color: string;
}

export default function Download() {
  const { data } = useQuery({
    queryKey: ["downloads"],
    queryFn: (): Promise<IItem[]> => axios.get(`${API_URL}/downloads`).then((res) => res.data),
  });

  return (
    <>
      <Container maxWidth="md">
        <Card sx={{ mb: 5, p: 3 }}>
          <Typography variant="h4" fontWeight="700" align="center" sx={{ mb: 5, color: "text.secondary" }}>
            سرویس ویژه + دی‌ان‌اس
          </Typography>

          <Grid container columnSpacing={5} rowGap={5} justifyContent="space-between">
            {data?.map((item, index) => {
              return (
                <>
                  <Grid item xs={12} md={5.5}>
                    <Stack spacing={2} alignItems="center">
                      <img src={item.picture} height="60px" />
                      <Typography variant="h6">{item.name}</Typography>
                    </Stack>

                    <Grid container columnSpacing={1} rowGap={1} mt={3}>
                      {item.link.map((i) => (
                        <Grid item xs={12} md={12 / item.link.length}>
                          <a href={i.url} target="_blank" style={{ width: "100%" }}>
                            <Button
                              onClick={() => addCount("downloads", i.id)}
                              size="large"
                              variant="contained"
                              sx={{
                                color: "#fff",
                                fontSize: "18px",
                                bgcolor: item.color,
                                px: 0,
                                "&:hover": { bgcolor: item.color },
                                width: "100%",
                              }}
                            >
                              {i.name}
                            </Button>
                          </a>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  {index === 0 && (
                    <Grid item xs={1}>
                      <Box sx={{ width: "1px", height: "100%", bgcolor: "#aaa", mx: "auto" }} />
                    </Grid>
                  )}
                </>
              );
            })}
          </Grid>
        </Card>

        <DNS />
      </Container>
    </>
  );
}
